import { pick } from 'lodash'
import QueryString from 'qs'
import { fetchFormValues } from '../../utils/formUtils/forms'
import { apiClient } from '../client'
import { PageListParams } from '../globalTypes'
import { DOCUMENT_VALUE_ENDPOINTS } from './formValuesConfig'
import { DocumentActionResponse, DocumentContactIdField, DocumentCriteria, DocumentValuesData, UploadDocumentParams } from './types'

export const getDocuments = async (id: number | string, params: PageListParams<DocumentCriteria>) => {
    const { page, limit, order, module, collection, criteria } = params

    const url = id ? `v1/file/parent/${id}` : 'v1/file'

    const criteriaObj = (criteria as Record<string, string | DocumentContactIdField>) ?? {}

    const criteriaParams = {
        collection: collection ?? 'document',
        ...(module ? { module } : {}),
        ...criteriaObj,
        // documentContactId is stored as object in Redux for AsyncSelectInput display — extract value (id) for request
        ...(typeof criteriaObj.documentContactId === 'object' &&
            criteriaObj.documentContactId?.value && { documentContactId: criteriaObj.documentContactId.value }),
    }

    const queryString = QueryString.stringify({ page, limit, order, criteria: criteriaParams })

    const response = await apiClient(`${url}?${queryString}`)
    return response.data
}

export const uploadDocument = async ({ formData, uploadUrl }: UploadDocumentParams) => {
    const response = await apiClient(`v1/file/upload/${uploadUrl}`, {
        method: 'POST',
        data: formData,
    })

    return response.data
}

export const deleteDocumentById = async (id: number): Promise<DocumentActionResponse> => {
    const response = await apiClient(`v1/file/${id}`, {
        method: 'DELETE',
    })

    return response.data
}

export const deleteMultipleDocuments = async (ids: number[]) => {
    const response = await apiClient(`v1/file`, {
        method: 'DELETE',
        data: {
            ids,
        },
    })

    return response.data
}

export const syncDocumentById = async (id: number): Promise<DocumentActionResponse> => {
    const response = await apiClient(`v1/file/sync/${id}`, {
        method: 'PUT',
    })
    return response.data
}

export const fetchDocumentValues = (fields?: string[]) => {
    const endpoints = fields ? pick(DOCUMENT_VALUE_ENDPOINTS, fields) : DOCUMENT_VALUE_ENDPOINTS
    return fetchFormValues<DocumentValuesData>(endpoints)
}
